import { AppState } from 'src/state/store'

export const receiveModalStateSelector = (state: AppState): boolean =>
  state.receiveModal.isOpened

export const selectedReceiveCurrIdSelector = (state: AppState): number =>
  state.receiveModal.selectedCurrencyId
